"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
var sanitized_render_1 = require("@reverbdotcom/commons/dist/components/sanitized_render");
var refund_request_1 = require("./refund_request");
var UNSUPPORTED_FA_ICONS = ['AUD', 'CAD'];
var PartialRefundAmount = function (props) {
    function renderCurrencySymbol(currency) {
        var currencyForIcon = lodash_1.includes(UNSUPPORTED_FA_ICONS, currency) ? 'usd' : currency;
        var iconClasses = "fa fa-" + currencyForIcon.toLowerCase();
        return (React.createElement("span", { className: "input-group__text", "data-price-with-currency-symbol": true },
            React.createElement("span", { className: iconClasses })));
    }
    function renderExchangedAmount() {
        if (!props.exchangedAmount) {
            return null;
        }
        return (React.createElement("div", { className: "currency-exchange-approximation mb-1" },
            React.createElement("div", { className: "panel strong" },
                React.createElement(sanitized_render_1.default, { className: "mb-0", htmlTag: "p", html: I18n.t('discovery.dashboard.refundRequests.exchangedAmount', {
                        amount: props.exchangedAmount.display,
                        settlementCurrency: props.order.settlementCurrency,
                        spanOpen: '<span class="price-currency">',
                        spanClose: '</span>',
                    }) }),
                React.createElement("p", { className: "mb-0 normal tight-line-height", ref: function (node) { return window.initTips && window.initTips(node); } },
                    I18n.t('discovery.dashboard.refundRequests.exchangedAmountHint', {
                        displayCurrency: props.order.displayCurrency,
                    }),
                    React.createElement("span", { className: "tooltip", title: I18n.t('discovery.dashboard.refundRequests.exchangedAmountTooltip', {
                            settlementCurrency: props.order.settlementCurrency,
                            displayCurrency: props.order.displayCurrency,
                            lineBreak: '<br/>',
                        }), "data-tooltip": "true" },
                        React.createElement("span", { className: "fa fa-question-circle" }))))));
    }
    if (props.refundType === refund_request_1.IRefundType.FULL && !props.refundRequest.isPersisted) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement("div", { className: "g-container scaling-mb-2" },
            React.createElement("div", { className: "g-col-4 g-col-mobile-12" },
                React.createElement("div", { className: "form-group" },
                    React.createElement("div", { className: "form-group__header" },
                        React.createElement("div", { className: "form-group__label-text" },
                            React.createElement("label", { htmlFor: "order_refund_request_amount" }, I18n.t('discovery.dashboard.refundRequests.amount'))),
                        React.createElement("div", { className: "form-group__tag" }, I18n.t('discovery.dashboard.refundRequests.required'))),
                    React.createElement("div", { className: "form-group__fields" },
                        React.createElement("div", { className: "input-group" },
                            renderCurrencySymbol(props.order.displayCurrency),
                            React.createElement("input", { type: "text", pattern: "[0-9.,\\s]*", onChange: props.onAmountChange, name: "order_refund_request[amount]", id: "order_refund_request_amount", value: props.amount, required: true, className: "input-group__input" }),
                            React.createElement("span", { className: "input-group__text" }, props.order.displayCurrency)))))),
        renderExchangedAmount()));
};
exports.default = PartialRefundAmount;
//# sourceMappingURL=partial_refund_amount.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/refund_requests/partial_refund_amount.js
// module id = sk7+
// module chunks = 20 21